export default "__VITE_ASSET__DFMGTFgy__"